import logo from './logo.svg';
import './App.css';
import MainLayout from './layouts/Main'
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom'
import { Home } from './pages/Home'
import LingvoSemantic from './pages/LingvoSemantic'
import { Settings } from './pages/Settings'
import { Stats } from './pages/Stats'
import { NotFound } from './pages/NotFound'
import { Images } from './pages/Images'
import Login from './pages/Login'
import { AuthProvider, useAuth } from './context/AuthContext';

// Компонент для условного редиректа
const RootRedirect = () => {
  const { user } = useAuth();
  return user ? <Navigate to="/home" replace /> : <Navigate to="/login" replace />;
};

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<Login />} />

            {/* Условный редирект с корневого пути */}
            <Route path="/" element={<RootRedirect />} />

            {/* Приватные маршруты (с layout) */}
            <Route element={<MainLayout />}>
              <Route path="/home" element={  
                <PrivateRoute>
                  <Home />
                </PrivateRoute>} />
              <Route path="/lingvo" element={
                 <PrivateRoute>
                  <LingvoSemantic />
                </PrivateRoute>} />
              <Route path="/visual" element={<Settings />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/" element={<Login />} />
          </Routes>
        </AuthProvider>
      </div>
    </BrowserRouter>
  );
}

export default App;
